(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
  function initImageAnimations() {
    const animatedImages = document.querySelectorAll(
      '.image-block[class*="image-block--animation-"]'
    );

    if (!animatedImages.length) {
      return;
    }

    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      animatedImages.forEach(function (block) {
        block.classList.add('is-visible');
      });

      return;
    }

    if (!('IntersectionObserver' in window)) {
      animatedImages.forEach(function (block) {
        block.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    animatedImages.forEach(function (block) {
      if (!block.classList.contains('is-visible')) {
        observer.observe(block);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initImageAnimations
    );
  } else {
    initImageAnimations();
  }

  document.addEventListener(
    'shopify:section:load',
    function () {
      initImageAnimations();
    }
  );

  document.addEventListener(
    'shopify:block:select',
    function (event) {
      const block = event.target.closest('.image-block');

      if (block) {
        block.classList.add('is-visible');
      }
    }
  );
})();
  } catch(e) { console.error(e); }
})();

})();
